import { DealStatus } from '@common/model/deal';
import { JSX, LazyExoticComponent, lazy } from 'react';
import { CheckmarkIcon, CloseIcon } from '@cp/ds/src/icons';
import { ClockNineIcon } from '@cp/ds/src/icons/career/properties/nannies';
import { withProps } from '@cp/ds/src/hocs';

export const DealMessageMarkAsRead = lazy(() =>
  import('../ui/DealMessageMarkAsRead').then((module) => ({ default: module.DealMessageMarkAsRead })),
);
export const DealMessageWidgets: Record<DealStatus, LazyExoticComponent<() => JSX.Element>> = {
  [DealStatus.Accepted]: lazy(() => import('../ui/DealMessageAccepted').then((module) => ({ default: module.DealMessageAccepted }))),
  [DealStatus.InProgress]: lazy(() => import('../ui/DealMessageInProgress').then((module) => ({ default: module.DealMessageInProgress }))),
  [DealStatus.Completed]: lazy(() => import('../ui/DealMessageCompleted').then((module) => ({ default: module.DealMessageCompleted }))),
  [DealStatus.Negotiation]: lazy(() =>
    import('../ui/DealMessageNegotionation').then((module) => ({ default: module.DealMessageNegotionation })),
  ),
  [DealStatus.Rejected]: lazy(() => import('../ui/DealMessageRejected').then((module) => ({ default: module.DealMessageRejected }))),
};
const DealMessagePreview = lazy(() => import('../ui/DealMessagePreview').then((module) => ({ default: module.DealMessagePreview })));
export const DealMessagePreviews: Record<DealStatus, ReturnType<typeof withProps>> = {
  [DealStatus.Accepted]: withProps(DealMessagePreview, {
    icon: CheckmarkIcon,
    color: 'green',
  }),
  [DealStatus.InProgress]: withProps(DealMessagePreview, {
    icon: CheckmarkIcon,
    color: 'brand gray',
  }),
  [DealStatus.Completed]: withProps(DealMessagePreview, {
    icon: CheckmarkIcon,
  }),
  [DealStatus.Negotiation]: withProps(DealMessagePreview, {
    icon: ClockNineIcon,
  }),
  [DealStatus.Rejected]: withProps(DealMessagePreview, {
    icon: CloseIcon,
    color: 'pink',
  }),
};
